export default __webpack_public_path__ + "static/Quantore-branding-vacatures-20bbaf8d8ef3303e221da13dfc09cd18.jpg";